<script>
/**
 * Per-channel New / In Progress counters, same figures the classic DataTable
 * widget renders from TicketService::statusCountsForIndex().
 */
export default {
    name: 'StatusCountsWidget',
    props: {
        /** [{ channel_name, counts: [{ count, label, variant }] }] */
        groups: { type: Array, default: () => [] },
    },
    computed: {
        visibleGroups() {
            return (this.groups || []).filter(
                (group) => group && Array.isArray(group.counts) && group.counts.length > 0,
            );
        },
    },
    methods: {
        boxClass(count) {
            return `tickets-index-counts__box--${count.variant || 'info'}`;
        },
    },
};
</script>

<template>
    <div
        v-if="visibleGroups.length"
        class="tickets-index-counts"
        :aria-label="'Ticket aperti per canale'"
    >
        <div
            v-for="group in visibleGroups"
            :key="group.channel_name"
            class="tickets-index-counts__channel"
        >
            <div
                class="tickets-index-counts__channel-name"
                :title="group.channel_name"
            >
                {{ group.channel_name }}
            </div>
            <div class="tickets-index-counts__pair">
                <div
                    v-for="count in group.counts"
                    :key="group.channel_name + '-' + count.label"
                    class="tickets-index-counts__box"
                    :class="boxClass(count)"
                >
                    <span class="tickets-index-counts__value">{{ count.count }}</span>
                    <span class="tickets-index-counts__label">{{ count.label }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
